import React from 'react';
import { VyEmptyState } from '../../../components/new-design/data-display/VyEmptyState';

export const ContractPageFallbackComponent: React.FC<{ text: string }> = ({ text }) => {
  return <VyEmptyState title={text} description={''} />;
};
